import React from "react";

const UserCards = ({ msg, onProfileClick, formatLocation }) => {
    // Return a single container with both freelancers and businesses
    return (
        <div className="cards-wrapper">
            {/* Freelancers */}
            {msg.freelancers?.length > 0 && (
                <div className="cards-container">
                    {msg.freelancers.map((f) => (
                        <div
                            key={f.id}
                            className="profile-card"
                            onClick={() => onProfileClick("freelancer", f.id)}
                        >
                            <div className="freelancer-img-container">
                                <img src={f.profile.photo_150_url || "/servspace-placeholder-500x500.png"} alt={f.profile.first_name} className="freelancer-img" />
                            </div>
                            <div className="profile-info">
                                <h4><span className="display-name">
                                    {[f.profile?.first_name, f.profile?.last_name].filter(Boolean).join(" ")}
                                </span>
                                </h4>

                                <span className="user-name">
                                    <span className="chat-pretty-at">@</span>
                                    {f.username || ""}
                                </span>
                                <div className="category-service">
                                    <i
                                        className={`fa-solid fa-wrench`}
                                    ></i>{" "}
                                    {f.profession?.name || "No profession listed"}
                                </div>
                                {(f.profile?.city || f.profile?.state) && (
                                    <div className="category-location">
                                        <i className="fa-solid fa-location-dot"></i> {" "}
                                        <span>
                                            {formatLocation(
                                                f.profile?.city,
                                                f.profile?.state,
                                            )}
                                        </span>
                                    </div>
                                )}
                                <div className="category-bottom">
                                    <div
                                        className="chat-category-subscribers"
                                    >
                                        <button
                                            className={`chat-save-button `}
                                        >
                                            <i className="fa-solid fa-heart"></i>
                                        </button>
                                        <span>{f.favorited_count || 0}</span>
                                    </div>


                                    <div
                                        className="chat-category-rating"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <i className="fa-solid fa-star"></i>
                                        <span>
                                            {f.average_rating && f.average_rating > 0
                                                ? Number.isInteger(f.average_rating)
                                                    ? f.average_rating
                                                    : f.average_rating.toFixed(1)
                                                : "0"}{" "}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Businesses */}
            {msg.businesses?.length > 0 && (
                <div className="cards-container">
                    {msg.businesses.map((b) => (
                        <div
                            key={b.id}
                            className="profile-card"
                            onClick={() => onProfileClick("business", b.id)}
                        >
                            <div className="business-img-container">
                                <img src={b.profile?.photo_300_url || "/servspace-business-placeholder.png"} alt={b.business_name} className="business-img" />
                            </div>
                            <div className="profile-info">
                                <div className="category-title">
                                    <h4><span className="display-name">
                                        {b.business_name || ""}
                                    </span>
                                    </h4>
                                    <span className="user-name">
                                        {b.username && (
                                            <span className="chat-pretty-at">@{b.username}</span>
                                        )}
                                    </span>
                                </div>
                                <div className="category-service">
                                    <i
                                        className={`fa-solid fa-store`}
                                    ></i>{" "}
                                    {b.profession?.name || "No profession listed"}
                                </div>
                                {(b.profile?.city || b.profile?.state) && (
                                    <div className="category-location">
                                        <i className="fa-solid fa-location-dot"></i> {" "}
                                        <span>
                                            {formatLocation(
                                                b.profile?.city,
                                                b.profile?.state,
                                            )}
                                        </span>
                                    </div>
                                )}

                                <div className="category-bottom">
                                    <div
                                        className="chat-category-subscribers"
                                    >
                                        <button
                                            className={`chat-save-button `}
                                        >
                                            <i className="fa-solid fa-heart"></i>
                                        </button>
                                        <span>{b.favorited_count || 0}</span>
                                    </div>


                                    <div
                                        className="chat-category-rating"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <i className="fa-solid fa-star"></i>
                                        <span>
                                            {b.average_rating && b.average_rating > 0
                                                ? Number.isInteger(b.average_rating)
                                                    ? b.average_rating
                                                    : b.average_rating.toFixed(1)
                                                : "0"}{" "}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default UserCards;